import { useEffect, useState } from 'react';
import Item from '../../../../components/Lists/Item';
import { NlaProvider } from '../../contexts/NlaContext';
import './EngineeringDialog.css';
import Interchangeability from './Interchangeability';
import { Kits } from './Kits';
import { Nla } from './Nla';
import { TimeControls } from './TimeControls';
import { getCategorySections } from '../../services/EngineeringService';
import { HTTP_RESPONSE_CODES } from '../../../../globals/globals';
import { Skeleton } from '@mui/material';
import { Effectivity } from './Effectivity';

// FIXME: the sections should be resolved by a backend service;
const categoriesBySection = {
  "interchangeability": new Set([2, 3, 4, 5]),
  "timeControls": new Set([2, 5]),
  "nla": new Set([2, 5]),
  "kits": new Set([36])
}

const EngineeringDialog = ({ onClose, part }) => {

  const showName = true;
  const [allowedSections, setAllowedSections] = useState(new Set([]));
  const [loadingSections, setLoadingSections] = useState(false);

  const handleClose =

  useEffect(() => {
    setLoadingSections(true);
    getCategorySections(part.categoryId).then(response => {
      if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
        let sectionKeys = response.data.load.map(i => i.engineeringSections.key);
        setAllowedSections(new Set(sectionKeys));

      }
      setLoadingSections(false);
    })
  }, [part])

  return (

    <div className="engineering-dialog-component">
      {/* <div>{JSON.stringify(part)}</div> */}
      <div className="dialog-header">
        <div className='title'>
          <h2>Engineering</h2>
          {part?.partNumber && <span className='title-part'>
            <span> PN </span>
            <b>{part?.partNumber || ''}</b>
            <span>Category</span>
            <b>{part.categoryName}</b>
            {showName && <><span>Description</span>
              <b>{part.name || part.description}</b></>}
          </span>}
        </div>
        <button className='outlined icon small-size' onClick={onClose}>
          <i className='icon-cross'></i>
        </button>
      </div>
      <div className='dialog-content'>
        {loadingSections && <>
          <Skeleton height="3rem" />
          <Skeleton height="3rem" />
          <Skeleton height="3rem" />
        </>}
        <>
          {/* <hr></hr> */}
          < Effectivity part={part} />
        </>
        {allowedSections.has("interchangeability") && <>
          <hr></hr>
          < Interchangeability part={part} /> </>}
        {allowedSections.has("timeControls") && <><hr></hr>
          <TimeControls part={part} /> </>}
        {allowedSections.has("nla") && <><hr></hr>
          <NlaProvider part={part}>
            <Nla part={part} />
          </NlaProvider> </>}
        {allowedSections.has("kits") && <> <hr></hr>
          <Kits part={part} /></>}
        {/* <div className='section'>
          <div className='section-header'>
            <h2>Kits</h2>
            <button className='outlined icon small-size'>
              <i className='icon-add-new'></i>
            </button>
          </div>
        </div> */}
      </div>

    </div >
  )
}

export default EngineeringDialog;